import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/customerUsageReport'
import Component from 'components/Reports/CustomerUsageReport'

export default createListViewContainer({ actions, selectors: selectors.customerUsageReport })(Component)
